// extracted by mini-css-extract-plugin
module.exports = {"loadingStyle":"ResourceUtilization_loadingStyle__12bKw"};